import { logoEfexInvoice } from '@/assets';
import HeaderStyles from './Header.style';
import LanguageComponent from '../LanguageComponent';

const Header = () => (
  <div className={HeaderStyles.wrapper}>
    <div className={HeaderStyles.avatarWrapper}>
      <img src={logoEfexInvoice} alt="Efex Logo" />
    </div>
    <LanguageComponent />
  </div>
);

export default Header;
